<div class="content-container">
    <div class="content-item-container" style="justify-content: flex-end;">
        <div class="wp-35" style="text-align: center;">
            <span *ngIf="bankValuesByAlias.numberMissingBankStatements3Month?.value > 0" matTooltip="This borrower is missing {{ bankValuesByAlias.numberMissingBankStatements3Month?.value }} statement(s) within the last 3 months">
                <i class="lendio-alert__icon fa fa-lg fa-exclamation-triangle"></i>
            </span>
            3 month avg.
        </div>
        <div class="wp-35" style="text-align: center;">
            <span *ngIf="bankValuesByAlias.numberMissingBankStatements6Month?.value > 0" matTooltip="This borrower is missing {{ bankValuesByAlias.numberMissingBankStatements6Month?.value }} statement(s) within the last 6 months">
                <i class="lendio-alert__icon fa fa-lg fa-exclamation-triangle"></i>
            </span>
            6 month avg.
        </div>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">
            Total Sales
        </p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.totaledSalesAmountAvg3Month?.value | currency : currencyCode) || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.totaledSalesAmountAvg6Month?.value | currency : currencyCode) || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">Sales Deposits</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.salesDepositsCountAvg3Month?.value | number : '1.2-2') || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.salesDepositsCountAvg6Month?.value | number : '1.2-2') || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">
            Cash Deposits
        </p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.creditsAmountAvg3Month?.value | currency : currencyCode) || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.creditsAmountAvg6Month?.value | currency : currencyCode) || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">Total Deposits</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.creditsCountAvg3Month?.value | number : '1.2-2') || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.creditsCountAvg6Month?.value | number : '1.2-2') || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">Negative Days</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.daysNegativeAvg3Month?.value | number : '1.2-2') || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.daysNegativeAvg6Month?.value | number : '1.2-2') || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">Batch Days</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.batchDaysCountAvg3Month?.value | number : '1.2-2') || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.batchDaysCountAvg6Month?.value | number : '1.2-2') || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">NSFs</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.nsfTransactionsAvg3Month?.value | number : '1.2-2') || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.nsfTransactionsAvg6Month?.value | number : '1.2-2') || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="content-item-container">
        <p class="wp-30" [ngClass]="{'text-muted' : basicStyle}">Avg. Balance</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.balanceAvg3Month?.value | currency : currencyCode) || '-' }}</p>
        <p class="wp-35 text-center">{{ (bankValuesByAlias.balanceAvg6Month?.value | currency : currencyCode) || '-' }}</p>
    </div>
    <mat-divider style="border-top-width: 1.7px; border-color: #D9DEE3"></mat-divider>
    <div class="tw-pl-3.5 tw-pt-3.5 tw-flex tw-align-items-baseline">
        <p class="tw-font-bold tw-italic">Last Bank Connection: </p>
        <p class="tw-pl-2 tw-italic tw-font-bold">{{ (bankConnection | date) || '-' }}</p>
    </div>
</div>
